export default __webpack_public_path__ + "static/webRotator/svg/e555d799020120ec49807db2b78f2966.svg";